<template>
  <div class="step">
    <ul class="step_area">
      <li class="step_area-box left" v-bind:class="{now:step==1}">
        <p class="step_area-box_text">
          <span class="step_area-box_text-small">STEP1</span>
          <span class="step_area-box_text-p">情報入力</span>
        </p>
      </li>
      <li class="step_area-box" v-bind:class="{now:step==2}">
        <p class="step_area-box_text">
          <span class="step_area-box_text-small">STEP2</span>
          <span class="step_area-box_text-p">入力確認</span>
        </p>
      </li>
      <li class="step_area-box" v-bind:class="{now:step==3}">
        <p class="step_area-box_text">
            <span class="step_area-box_text-small">STEP3</span>
            <span class="step_area-box_text-p">送信完了</span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "form_step",
  props:{step:Number},
};
</script>

<style lang="scss">

.step {
  .now {
    background-color: #707070;
    border-color: #707070;
    color: #ffffff;
    &::after,
    &::before {
      background-color: #707070;
    }
  }
  &_area { 
    display: flex;
    justify-content: center;
    list-style: none;
    &-box {
      background-color: #f2f2f2;
      position: relative;
      display: flex;
      align-items: center;
      &:first-child {
        &::before,
        &::after {
          transform: skew(0deg);
        }
      }
      &::before {
        position: absolute;
        left: -8%;
        content: "";
        background-color: #f2f2f2;
        border-left: 4px solid #ffffff;
        bottom: 0;
        transform: skew(-30deg);
      }
      &::after {
        position: absolute;
        left: -8%;
        content: "";
        background-color: #f2f2f2;
        border-left: 4px solid #ffffff;
        top: 0;
        transform: skew(30deg);
      }
      &_text {
        display: grid;
        justify-content: center;
        text-align: center;
        &-small {
          font-size: 80%;
        }
      }
    }
  }
}
//pc
@media screen and (min-width: 769px) {
  .step {
  &_area {
    max-width: 800px;
    margin:  10px auto 25px;
    .left{
      margin-left:-20px;
    }
    &-box {
      padding-left:7%;
      width: 190px;
      height: 70px;
      &::before {
        width: 15%;
        height: 35px;
      }
      &::after {
        width: 16%;
        height: 35px;
      }
      }
    }
  }
}
//smartphone
@media screen and (max-width: 768px) {
  .step {
  &_area { 
    margin-left: -9%;
    &-box {
      width: 100%;
      height: 4em;
      &::before {
        width: 15%;
        height: 2em;
      }
      &::after {
        width: 15%;
        height: 2em;
      }
      &_text {
        width: 90%;
      }
    }
  }
}
}
</style>